import { render, staticRenderFns } from "./whatsapp.vue?vue&type=template&id=73393a7c&"
import script from "./whatsapp.vue?vue&type=script&lang=js&"
export * from "./whatsapp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73393a7c')) {
      api.createRecord('73393a7c', component.options)
    } else {
      api.reload('73393a7c', component.options)
    }
    module.hot.accept("./whatsapp.vue?vue&type=template&id=73393a7c&", function () {
      api.rerender('73393a7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/whatsapp.vue"
export default component.exports